module.exports = __webpack_public_path__ + "img/the-good-luck-girls.7729b5b9.png";